import React, { useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OnboardingLayout from "component/auth/OnboardingLayout";
import { BankIcon, TradevuIcon } from "asset/icons";
import { MdOutlineArrowForwardIos } from "react-icons/md";

const SendMoney = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectedCurrency = useSelector((state) => state.currency);
    const transferType = location.state?.type;
    const activeCurrency = String(
        selectedCurrency || location.state?.default || localStorage.getItem("default") || "NGN"
    ).toUpperCase();
    const initialCurrency = useRef(activeCurrency).current;

    useEffect(() => {
        dispatch({ type: "CURRENCY", payload: initialCurrency });
        localStorage.setItem("default", initialCurrency);
    }, [dispatch, initialCurrency]);

    // Match if we're on /payment/send-money directly
    const isBaseRoute = location.pathname === "/payment/send-money";

    const options = [
        {
            title: "Tradevu user",
            subtitle: "Send money to a Tradevu account",
            icon: <TradevuIcon />,
            route: "/payment/send-money/same-currency/tradevu-user/amount",
        },
        {
            title: "Bank recipient",
            subtitle: "Send money to any bank account",
            icon: <BankIcon />,
            route:
                transferType === "same"
                    ? "/payment/send-money/same-currency/bank-recipient/amount"
                    : "/payment/send-money/cross-border/bank-recipient/amount",
        },
    ];

    return (
        <>
            {isBaseRoute ? (
                <OnboardingLayout title="Send money" showSkip={false}>
                    <div className="min-h-screen sm:px-8 md:px-12 py-10">
                        <div className="w-full max-w-xl mx-auto flex flex-col">
                            <h2 className="text-xl font-medium mb-6">Who are you sending to?</h2>
                            {options.map(({ title, subtitle, icon, route }) => (
                                <div
                                    key={title}
                                    className="flex items-center justify-between p-4 bg-white cursor-pointer transition"
                                    onClick={() =>
                                        navigate(route, {
                                            state: {
                                                ...location.state,
                                                default: activeCurrency,
                                            },
                                        })
                                    }
                                >
                                    <div className="flex items-center gap-2">
                                        <div className="">{icon}</div>
                                        <div>
                                            <p className="font-medium">{title}</p>
                                            <p className="text-sm text-gray-500">{subtitle}</p>
                                        </div>
                                    </div>
                                    <MdOutlineArrowForwardIos className="text-[#27293F]" />
                                </div>
                            ))}
                        </div>
                    </div>
                </OnboardingLayout>
            ) : (
                <Outlet />
            )}
        </>
    );
};

export default SendMoney;
